import React, { useEffect, useState} from 'react';
import CountUp from 'react-countup';
import LiveTenderIcon from '../../Assets/icon/liveTenderIcon.png';
import publishTenderIcon from '../../Assets/icon/publishTenderIcon.png';
import privetTenderIcon from '../../Assets/icon/privetTenderIcon.png';
import corrigendumIcon from '../../Assets/icon/corrigendumIcon.png';
import apiClient from '../../Api/apiClient';
import { API_BASE_URL } from './../../Api/config';

const Counter = () => {

  const [liveTender, setLiveTender] = useState();
  const [privetTender, setPrivetTender] = useState();
  const [publishTender, setPublishTender] = useState();
  const [corrigendumTender, setCorrigendumTender] = useState();

  useEffect(() => {
    const fetchLiveTender = async ()=>{
      try {
        const response = await apiClient.get(`${API_BASE_URL}/user/summary-view/live`);
        setLiveTender(response.data.total_live_tender);
      } catch (error) {
        console.log(error);
      }
    } 
    fetchLiveTender();
  },[])

  useEffect(() => {
    const fetchPrivetTender = async () => {
      try {
        const response = await apiClient.get(
          `${API_BASE_URL}/user/summary-view/private`
        );
        setPrivetTender(response.data.total_private);
      } catch (error) {
        console.log(error);
      }
    }; 
    fetchPrivetTender();
  }, [])
  
  useEffect(() => {
    const fetchCorrigendumTender = async () => {
      try {
        const response = await apiClient.get(
          `${API_BASE_URL}/user/summary-view/corrigendum`
        );
        setCorrigendumTender(response.data.total_corrigendum);
      } catch (error) {
        console.log(error);
      }
    }; 
    fetchCorrigendumTender();
  }, [])
  
  useEffect(() => {
    const fetchPublishTender = async () => {
      try {
        const response = await apiClient.get(
          `${API_BASE_URL}/user/summary-view/publish-today`
        );
        setPublishTender(response.data.total_publish_today);
      } catch (error) {
        console.log(error);
      }
    }; 
    fetchPublishTender();
  },[])


  const counter = [
    { id: 1, count: liveTender, text: 'Live Tenders', icon: LiveTenderIcon },
    {
      id: 2,
      count: corrigendumTender,
      text: 'Corrigendum',
      icon: corrigendumIcon,
    },
    {
      id: 3,
      count: privetTender,
      text: 'Private Tenders',
      icon: privetTenderIcon,
    },
    {
      id: 4,
      count: publishTender,
      text: 'Publish Today',
      icon: publishTenderIcon,
    },
  ];

  return (
    <div className="container mx-auto max-w-7xl">
      <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 flex-wrap items-center justify-center md:space-y-0 space-y-2 space-x-0 md:space-x-10 md:mt-14 2xl:mt-24 mt-4 md:px-24 px-4 md:py-16 2xl:py-20 py-6 md:ml-0 2xl:ml-0 ml-6">
        {counter.map(item => (
          <div key={item.id}>
            <div className="flex items-center gap-4">
              <img src={item.icon} alt="" className="2xl:h-16 md:h-14 h-6" />
              <div className="md:gap-4 gap-2 items-center">
                {/* CountUp component for animated numbers */}
                <h1 className="text-sm md:text-xl 2xl:text-2xl text-black font-bold md:mb-2 mb-1">
                  <CountUp
                    start={0}
                    end={item.count}
                    duration={2.5}
                    separator=","
                  />
                </h1>
                <p className="text-CounterTextColor font-bold text-xs md:text-lg">
                  {item.text}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Counter;
